(function() {

    'use strict';

    angular.module('Services').factory('FTPHistoricalInputsTable', FTPHistoricalInputsTable);

    FTPHistoricalInputsTable.$inject = [
        'ManifestService', 
        'TableLiteFactory',
        'ConfirmationModalFactory',
        'toastr',
        'Units',
        '$rootScope',
        '$filter'
    ];

    function FTPHistoricalInputsTable(
        ManifestService, 
        TableLiteFactory,
        ConfirmationModalFactory,
        toastr,
        Units,
        $rootScope,
        $filter
    ) {

        return function () {
            const viewConfirmation = new ConfirmationModalFactory({}, {
                message: 'messages.warning.ftpImportNow.MESSAGE',
                code: 'messages.warning.ftpImportNow.CODE',
            });
            var tableData = {
                tableName: 'FTPHistoricalTable',
                optionAddOns: {
                    buttons: [{
                        class: 'btn-primary',
                        label: 'Import Now',
                        /*tooltip: 'Click to import ',*/
                        onClick: function () {
                            if(!tableData.optionAddOns.uprocessedFilesLength){
                                toastr.info('No files to import');
                                return false;
                            }
                            viewConfirmation.getInstance().result.then(function (cond) {
                                if (cond) {
                                    ManifestService.importFTPUnprocessedFilesNow(()=>
                                        toastr.success(`Successfully imported ${tableData.optionAddOns.uprocessedFilesLength} file(s)`),
                                        error=>toastr.error('Unable to import files', error.message)
                                    )
                                }
                            });
                        }
                    }],
                    wrapperClass: 'pull-right',
                    url: '/templates/pages/manifests/addOns/ftpDirectHistoryOptions.html'
                },
                config: {
                    noPagination: false,
                    noHeaders: false,
                    noItemsView: false,
                    noTableFooter: false,
                },
                headers: [{
                    label: "RUN ID",
                    viewName: "runId",
                    filterName: "runId",
                    filter: {
                        type: 'text',
                        placeholder: "Search",
                        onSubmit: header=>{
                            sendRequest(evaluateFilter(header));
                        }
                    },
                    headerFn: function () {
                        sort(this.filterName);
                    }
                },{
                    label: "DATE & TIME",
                    viewName: "createdDateFormatted",
                    filterName: "createdDate",
                    /*"filter: {
                        type: "text",
                        placeholder: "Search",
                        onSubmit: header=>{
                            sendRequest(evaluateFilter(header));
                        }
                    },*/
                    headerFn: function () {
                        sort(this.filterName);
                    }
                },{
                    label: "NO. OF SHIPMENTS",
                    viewName: "numberShipments",
                    filterName: "numberShipments",
                    filter: {
                        type: "text",
                        placeholder: "Search",
                        onSubmit: header=>{
                            sendRequest(evaluateFilter(header));
                        }
                    },
                    headerFn: function () {
                        sort(this.filterName);
                    }
                }, {
                    label: "STATUS",
                    viewName: "importStatusFormatted",
                    filterName: "importStatus",
                    /*filter: {
                        type: "text",
                        placeholder: "Search",
                        onSubmit: header=>{
                            sendRequest(evaluateFilter(header));
                        }
                    },*/
                    headerFn: function () {
                        sort(this.filterName);
                    }
                }, {
                    label: 'TOTAL CUBIC',
                    viewName: 'totalCubicFormatted',
                    filterName: 'totalCubic',
                    headerFn: function () {
                        tableActions.sort(this.filterName);
                    }
                }, {
                    label: 'COMMENTS',
                    viewName: 'commentsFormatted',
                    filterName: 'comments',
                    headerFn: function () {
                        sort(this.filterName);
                    }
                }, {
                    label: 'ACTIONS',
                    viewName: 'actions',
                    filterName: 'actions',
                    headerFn: function () {
                        sort(this.filterName);
                    }
                }],
                data: []
            };
            const tableActions = new TableLiteFactory(tableData,
                {
                    serviceCallback: ManifestService.getFTPHistoricalInputs,
                    callbackFormat: ['success','error','filter'],
                    postRequestCallback: data => {
                        tableData.optionAddOns.uprocessedFilesLength = 'N/A';
                        ManifestService.getFTPUnprocessedFiles(function (data) {
                            tableData.optionAddOns.uprocessedFilesLength = data.total;
                        });
                        buildTableData(data);
                    },
                    postRequestErrorCallback: err => {
                        buildTableData(null);
                        toastr.error(err);
                    },
                    defaultFilters : {
                        size: 20,
                        page: 0,
                        sort: 'id,desc'
                    }
                }
            );
            const sort = tableActions.sort;
            const evaluateFilter = tableActions.evaluateFilter;
            const sendRequest = tableActions.sendRequest;

            function buildTableData(data) {
                /*** START - Building of Data ***/
                tableActions.initializeTableData(data);
                angular.forEach(data.content, function (item) {
                    const date = new Date(item.date);
                    const timeZone = date.toLocaleTimeString('en-us',{timeZoneName:'short'}).split(' ')[2];
                    const dateFormatted = $filter('bbaDate')(item.date);
                    const hour = date.getHours();
                    const min = date.getMinutes();
                    item.createdDateFormatted = `${dateFormatted} ${hour}:${min} ${timeZone}`;
                    item.importStatusFormatted = `${item.imported} IMPORTED, ${item.failed} FAILED`;
                    item.totalCubicFormatted = item.totalCubic + ' ' + Units.getMeasureUnit($rootScope.GlobalProfile.office.measureUnit);
                    item.commentsFormatted = item.comments || 'N/A';
                    item.actions = {
                        type: 'button',
                        buttons: [{
                            text: 'View shipments',
                            class: 'btn btn-primary',
                            action: row => {

                            }
                        }, {
                            text: 'View manifest',
                            class: 'btn btn-primary',
                            action: row => {

                            }
                        }]
                    };
                    tableData.data.push(item);
                });
            };
            this.tableData = tableData;
        };
    };
})();


// WEBPACK FOOTER //
// ./js/services/tables/manifests/FTPHistoricalInputsTable.js